import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import useClickOut from 'hooks/useClickOut'
import React, { useEffect, useRef, useState } from 'react'
import widgetsApi from 'services/api/widgets'

import fileUplaoderStyles from './FileUploaderDialog.module.scss'

const FileUploaderDialog = ({
  onClickout,
  onLoad,
  onData,
  onUpdateFiles,
  onClickRecentFile,
  kind,
  allowImageValidateSize = false,
  imageValidateSizeMinWidth = 0,
  imageValidateSizeMinHeight = 0,
  top,
  left
}) => {
  const wrapperRef = useRef()

  useClickOut(wrapperRef, onClickout)

  const [recentFiles, setRecentFiles] = useState([])

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)

    widgetsApi.files.get(kind).then(data => {
      setRecentFiles(data)
      setIsLoading(false)
    })
  }, [kind])

  return (
    <div className={fileUplaoderStyles.wrapper} ref={wrapperRef} style={{ top, left }}>
      <div className={fileUplaoderStyles.dragAndDropHolder}>
        <MemoizedDragAndDropUploader
          onLoad={onLoad}
          onData={onData}
          onUpdateFiles={onUpdateFiles}
          kind={kind}
          allowImageValidateSize={allowImageValidateSize}
          imageValidateSizeMinWidth={imageValidateSizeMinWidth}
          imageValidateSizeMinHeight={imageValidateSizeMinHeight}
        />
      </div>
      {!isLoading && recentFiles?.length > 0 && (
        <>
          <p className={fileUplaoderStyles.recentFilesTitle}>Select from recent files</p>
          <div className={fileUplaoderStyles.recentFiles}>
            {recentFiles
              ?.reverse()
              ?.slice(0, 5)
              ?.map(file => (
                <div
                  key={file}
                  onClick={() => onClickRecentFile(file)}
                  className={fileUplaoderStyles.recentFile}
                  style={{ backgroundImage: `url(${file})` }}
                />
              ))}
          </div>
        </>
      )}
    </div>
  )
}

const MemoizedDragAndDropUploader = React.memo(
  ({
    onUpdateFiles,
    onData,
    onLoad,
    kind,
    allowImageValidateSize,
    imageValidateSizeMinWidth,
    imageValidateSizeMinHeight
  }) => (
    <DragAndDropUploader
      url="/widgets/files" // make this dynamic too
      acceptedFileTypes={['image/*']}
      maxFiles={1}
      onUpdateFiles={onUpdateFiles}
      onData={formData => {
        formData.append('kind', kind)
        onData(formData)
        return formData
      }}
      allowImageValidateSize={allowImageValidateSize}
      imageValidateSizeMinWidth={imageValidateSizeMinWidth}
      imageValidateSizeMinHeight={imageValidateSizeMinHeight}
      onLoad={props => {
        onLoad(props)
      }}
      labelIdle="
<p class='filepond-p-mini'>drop a file here</p>
<span class='filepond-or'>or</span> <span class='filepond--label-action-mini'>Select file</span>"
    />
  )
)

export default FileUploaderDialog
